
import { mapGetters } from 'vuex';

export default {
  props: ['setModal'],
  computed: mapGetters(['getStaticLanguage']),
};
